import React, { Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { S_Xmark } from 'hosman-material';

const Modal = ({ children, isOpen, closeModal }) => {
  let completeButtonRef = useRef(null)

  const handleClose = () => {
    if (closeModal) closeModal();
  };

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog initialFocus={completeButtonRef} as='div' className='relative z-40' onClose={handleClose}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-ih-neutral backdrop-blur bg-opacity-20' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto mt-0'>
            <div className='m-auto w-full flex min-h-full items-center justify-center p-4'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='relative transform overflow-hidden rounded-2xl shadow-xl transition-all border border-white w-full md:w-auto'>
                  {closeModal &&
                    <div className='absolute top-3 right-3 z-10'>
                      <div className='bg-ih-blue text-white rounded-3xl w-8 h-8 text-center cursor-pointer flex items-center justify-center' ref={completeButtonRef} onClick={closeModal}>
                        <FontAwesomeIcon icon={S_Xmark} />
                      </div>
                    </div>
                  }
                  
                  { children }
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
};

export default Modal;

Modal.prototype = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func
}
